// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__-DVaX","actionsCol":"EnrolledClinics_actionsCol__21suc"};